import { render, staticRenderFns } from "./AuthoriseLabour.vue?vue&type=template&id=639e1bf8&scoped=true"
import script from "./AuthoriseLabour.vue?vue&type=script&lang=js"
export * from "./AuthoriseLabour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e1bf8",
  null
  
)

export default component.exports